export default function Resize(base64Image: string | undefined, maxSizeInMB: number) {
  if (!base64Image) return '';

  return new Promise<string>((resolve) => {
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    const img = new Image();
    img.src = base64Image;
    // eslint-disable-next-line func-names
    img.onload = function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const { width, height } = img;
      const aspectRatio = width / height;
      const newWidth = Math.sqrt(maxSizeInBytes * aspectRatio);
      const newHeight = Math.sqrt(maxSizeInBytes / aspectRatio);
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx?.drawImage(img, 0, 0, newWidth, newHeight);
      const quality = 0.8;
      const dataURL = canvas.toDataURL('image/jpeg', quality);
      resolve(dataURL);
    };
  });
}
